import React, { useEffect, useState } from "react";
import { Package, Mail, Tag, Printer, Layers } from "lucide-react";
import { adminStats } from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminStats().then(setStats).catch(() => setStats(null));
  }, []);

  return (
    <div className="p-8 md:p-12" data-testid="admin-dashboard">
      <div className="font-mono-sm text-xs tracking-[0.3em] uppercase text-[#E84E34] mb-3">// DASHBOARD</div>
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Visão geral</h1>
      <p className="mt-2 text-sm text-[#6B7280]">Acompanhe produtos publicados e contatos recebidos.</p>

      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
        <StatCard icon={Package} label="Produtos totais" value={stats?.products_total ?? "—"} />
        <StatCard icon={Mail} label="Contatos recebidos" value={stats?.contacts_total ?? "—"} accent />
        <StatCard icon={Printer} label="Impressoras" value={stats?.products_by_category?.Impressoras ?? "—"} />
        <StatCard icon={Tag} label="Etiquetas + Ribbons" value={(stats?.products_by_category?.Etiquetas ?? 0) + (stats?.products_by_category?.Ribbons ?? 0)} />
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
        <div className="bg-white p-8">
          <Layers size={24} className="text-[#E84E34]" />
          <h3 className="font-display text-xl font-bold mt-4">Produtos por categoria</h3>
          <ul className="mt-5 divide-y divide-[#E5E7EB] border-y border-[#E5E7EB]">
            {Object.entries(stats?.products_by_category || {}).map(([k, v]) => (
              <li key={k} className="flex items-center justify-between py-3 text-sm">
                <span className="text-[#6B7280] uppercase tracking-[0.15em] text-xs font-bold">{k}</span>
                <span className="font-display text-lg font-black">{v}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="bg-white p-8">
          <Mail size={24} className="text-[#E84E34]" />
          <h3 className="font-display text-xl font-bold mt-4">Atalhos</h3>
          <div className="mt-5 space-y-3">
            <a href="/admin/produtos" className="block p-4 border border-[#E5E7EB] hover:border-[#1A1A1A] transition-colors">
              <div className="text-xs font-mono-sm uppercase tracking-[0.2em] text-[#6B7280]">Gerenciar</div>
              <div className="font-display text-lg font-bold mt-1">Produtos & Catálogo →</div>
            </a>
            <a href="/admin/contatos" className="block p-4 border border-[#E5E7EB] hover:border-[#1A1A1A] transition-colors">
              <div className="text-xs font-mono-sm uppercase tracking-[0.2em] text-[#6B7280]">Visualizar</div>
              <div className="font-display text-lg font-bold mt-1">Mensagens do site →</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

const StatCard = ({ icon: Icon, label, value, accent }) => (
  <div className={`p-6 md:p-8 ${accent ? "bg-[#1A1A1A] text-white" : "bg-white"}`}>
    <Icon size={22} strokeWidth={1.6} className={accent ? "text-[#E84E34]" : "text-[#E84E34]"} />
    <div className={`font-mono-sm text-[10px] tracking-[0.25em] uppercase mt-4 ${accent ? "text-white/60" : "text-[#6B7280]"}`}>{label}</div>
    <div className="font-display text-4xl font-black mt-1">{value}</div>
  </div>
);
